import styled from '@emotion/styled'
import { MdErrorOutline } from 'react-icons/md'

export const styledAlertIcon = styled(MdErrorOutline)`
  label: styledAlertIcon;
  color: #721c24;
  height: 1.4em;
  width: 1.4em;
  position: absolute;
  left: 8px;
  top: 28px;
`
export const SubMenuContainer = styled('div')`
  label: SubMenuContainer;
  position: sticky;
  top: 0;
  z-index: 10;
`
